import { useApplicationContext } from '../../containers/ApplicationContext';

// @todo сделаем на нормальных данных, когда будет готов бэк, прогресс тут https://jira.cian.tech/browse/SUT-289
export const useIsDailyrentOnlineBookingEnabled = () => {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Dailyrent.OnlineBookingFrontend.Enabled');
};
